import axios from "axios";
import { db } from "./offlineDB";
import { env } from "../constants/env";

const SECTIONS = [
  "Assessment",
  "Documents & Records",
  "Continual Improvement",
  "Customer Focus",
  "Equipment Management",
  "Facilities & Safety",
  "Information Management",
  "Inventory Management",
  "Non-Conforming Events",
  "Organization & Leadership",
  "Personnel Management",
  "Process Management",
]; // extend later if needed

export const prefetchCertificationsAndQuestionnaires = async (token) => {
  console.log("WE ARE HERE!!!");

  if (!navigator.onLine) return;

  try {
    const labs = await db.offlineLabs.toArray();

    for (const lab of labs) {
      for (const section of SECTIONS) {
        // 1️⃣ Get summaries
        const summaries = await prefetchCertificationSummary({
          labId: lab.id,
          section,
          token,
        });

        // 2️⃣ Fetch each questionnaire by certificateId
        for (const summary of summaries) {
          await prefetchQuestionnaireByCertificateId({
            certificateId: summary._id,
            labId: lab.id,
            section,
            token,
          });
        }
      }
    }

    console.log("✅ Certifications & questionnaires prefetch complete");
  } catch (err) {
    console.error("❌ Prefetch certifications failed:", err.message);
  }
};

const prefetchCertificationSummary = async ({ labId, section, token }) => {
  const res = await axios.get(`${env.kataApiUrl}/api/certification/summary`, {
    params: { labId, section, name: "SLIPTA" },
    headers: { Authorization: `Bearer ${token}` },
  });

  for (const item of res.data) {
    const existing = await db.offlineCertifications.get(item._id);

    if (existing?.offline) {
      console.log(
        "[Prefetch] Skipped summary overwrite — local offline edits exist",
        item._id
      );
      continue;
    }

    const offlineId =
      item._id && typeof item._id === "string"
        ? item._id
        : `offline-${crypto.randomUUID()}`;

    await db.offlineCertifications.put({
      ...item,
      id: offlineId, // ✅ must be valid
      labId,
      section,
      offline: false,
      lastSynced: new Date().toISOString(),
      timestamp: Date.now(),
    });
  }

  console.log(`[Prefetch] Summary cached for lab ${labId}`);

  return res.data; // ✅ IMPORTANT
};

const prefetchQuestionnaireByCertificateId = async ({
  certificateId,
  labId,
  section,
  token,
}) => {
  const res = await axios.get(
    `${env.kataApiUrl}/api/certification/id/${certificateId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  const questionnaire = res.data; // ✅ single object

  const existing = await db.offlineCertifications.get(questionnaire._id);

  if (existing?.offline) {
    console.log(
      "[Prefetch] Skipped questionnaire overwrite — local offline edits exist",
      questionnaire._id
    );
    return;
  }

  const offlineId =
    questionnaire._id && typeof questionnaire._id === "string"
      ? questionnaire._id
      : `offline-${crypto.randomUUID()}`;

  await db.offlineCertifications.put({
    ...questionnaire,
    id: offlineId,
    labId,
    section,
    offline: false,
    lastSynced: new Date().toISOString(),
    timestamp: Date.now(),
  });

  console.log(`[Prefetch] Questionnaire cached ${certificateId}`);
};
